"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELegalStatusTrads = void 0;
exports.ELegalStatusTrads = {
    natural: "Personne physique",
    legal: "Personne morale",
};
